// @flow
import React from 'react';
import styled from 'styled-components';
import moment from 'moment';

import Scrollable from '../../components/shared/Scrollable';
import { colors } from '../../shared/styles';

const ListContent = styled.div`
    .list-content {
        height: calc(100vh - 152px);
        padding-bottom: 70px;
    }

    .simplebar-content {
        overflow-x: hidden;
    }
`;

const StyledTable = styled.table`
    max-width: 100%;
    width: 100%;
    text-align: left;

    &,
    tbody,
    tfoot,
    thead,
    tr,
    th,
    td {
        margin: 0;
        padding: 0;
        border: 0;
        font-size: 100%;
        vertical-align: baseline;
        border-collapse: collapse;
        border-spacing: 0;
        text-align: left;
    }

    & {
        width: 100%;
    }

    thead {
        background: #edf1f2;
        overflow: hidden;
        border-bottom: 1px solid #d9d9db;
    }

    th {
        box-sizing: border-box;
        width: calc((100% - 100px) / 3);
        font-weight: normal;
        text-align: left;
        padding: 15px 20px;

        &:last-of-type {
            width: 95px;
        }
    }

    tbody {
        tr {
            font-weight: lighter;
            background: #f3f3f5;

            &:nth-of-type(odd) {
                background: ${colors.white};
            }
        }
    }

    td {
        padding: 10px 20px;
        font-size: 14px;
    }

    .actions {
        list-style-type: none;
        margin: 0;
        padding: 0;
        background: #e76424;
        color: #fff;
        position: relative;
        border-radius: 4px;
        cursor: pointer;
        font-size: 14px;

        &:hover {
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;

            ul {
                display: block;
            }
        }

        span {
            padding: 7px 15px;
            display: block;
        }

        ul {
            position: absolute;
            left: 0;
            display: none;
            list-style-type: none;
            margin: 0;
            padding: 0;
            width: 100%;
            z-index: 2;
            background: #e76424;
            border-bottom-left-radius: 4px;
            border-bottom-right-radius: 4px;

            li {
                border-top: solid 1px #fff;
            }
        }

        .action-btn:last-child {
            margin-right: 0;
        }
    }

    & .action-btn {
        position: relative;
        display: inline-block;
        margin: 8px 8px 8px 0;
        background: ${colors.orange.default};
        color: ${colors.white};
        border: none;
        border-radius: 4px;
        text-align: center;
        text-decoration: none;
        padding: 8px 16px;
        font-size: 14px;
        white-space: nowrap;
        cursor: pointer;
    }

    & .action-btn .tooltip {
        position: absolute;
        font-size: 12px;
        width: 140px;
        color: #ffffff;
        background: #48555b;
        height: 30px;
        line-height: 30px;
        text-align: center;
        visibility: hidden;
        border-radius: 4px;
    }

    & .action-btn .tooltip:after {
        content: '';
        position: absolute;
        top: 50%;
        left: 100%;
        margin-top: -8px;
        width: 0;
        height: 0;
        border-left: 8px solid #48555b;
        border-top: 8px solid transparent;
        border-bottom: 8px solid transparent;
    }
    & .action-btn:hover .tooltip {
        visibility: visible;
        right: 100%;
        top: 50%;
        margin-top: -15px;
        margin-right: 13px;
        z-index: 999;
    }
`;

const List = (props: {
    boards: Object,
    labels: Object,
    onStatusChange: Function,
    onViewBoard: Function,
}) => {
    const { boards, labels, onStatusChange, onViewBoard } = props;

    return (
        <ListContent>
            <Scrollable additionalClassName="list-content">
                <StyledTable>
                    <thead>
                        <tr>
                            <th>Ref No</th>
                            <th>Instruction</th>
                            <th>Type</th>
                            <th>Placement</th>
                            <th>Order Date</th>
                            <th>Phone</th>
                            <th>Status</th>
                            <th />
                        </tr>
                    </thead>
                    <tbody>
                        {boards
                            ? Object.keys(boards).map(boardId => {
                                  const board = boards[boardId];
                                  const status = board.toLetBoardCompletedAt
                                      ? 'Completed'
                                      : 'Pending';

                                  const dateOrdered = moment(
                                      board.toLetBoardCreatedAt
                                  ).format('DD/MM/YYYY [at] h:mma');

                                  return (
                                      <tr key={boardId}>
                                          <td>
                                              {board.property.propertyReference}
                                          </td>
                                          <td>
                                              {
                                                  labels.instructions[
                                                      board
                                                          .toLetBoardInstruction
                                                  ]
                                              }
                                          </td>
                                          <td>
                                              {
                                                  labels.type[
                                                      board.toLetBoardBoardType
                                                  ]
                                              }
                                          </td>
                                          <td>
                                              {
                                                  labels.placement[
                                                      board.toLetBoardPlacement
                                                  ]
                                              }
                                          </td>
                                          <td>
                                              {dateOrdered}
                                          </td>
                                          <td>TBC...</td>
                                          <td>
                                              {status}
                                          </td>
                                          <td style={{ minWidth: 110 }}>
                                              <button
                                                  className="action-btn"
                                                  onClick={e => {
                                                      onViewBoard(boardId);
                                                  }}
                                              >
                                                  <i className="fa fa-eye" />
                                                  <span className="tooltip">
                                                      View Details
                                                  </span>
                                              </button>

                                              {board.toLetBoardCompletedAt &&
                                                  <button
                                                      className="action-btn"
                                                      onClick={e => {
                                                          onStatusChange(
                                                              boardId,
                                                              'PENDING'
                                                          );
                                                      }}
                                                  >
                                                      <i className="fa fa-undo" />
                                                      <span className="tooltip">
                                                          Mark Pending
                                                      </span>
                                                  </button>}
                                              {!board.toLetBoardCompletedAt &&
                                                  <button
                                                      className="action-btn"
                                                      onClick={e => {
                                                          onStatusChange(
                                                              boardId,
                                                              'COMPLETED'
                                                          );
                                                      }}
                                                  >
                                                      <i className="fa fa-check" />
                                                      <span className="tooltip">
                                                          Mark Complete
                                                      </span>
                                                  </button>}
                                          </td>
                                      </tr>
                                  );
                              })
                            : null}
                    </tbody>
                </StyledTable>
            </Scrollable>
        </ListContent>
    );
};

export default List;



// WEBPACK FOOTER //
// ./src/components/ToLetBoards/List.js